export const authLocale = (locale: string) => {
  return (loginEnabledLocales.includes(locale as LoginEnabledLocale) ? locale : 'en-US') as LoginEnabledLocale;
};

const loginEnabledLocales = [
  'af-ZA',
  'am-ET',
  'ar-SA',
  'be-BY',
  'bg-BG',
  'bn-BD',
  'ca-ES',
  'cs-CZ',
  'cy-GB',
  'da-DK',
  'de-DE',
  'el-GR',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-US',
  'es-ES',
  'es-LA',
  'et-EE',
  'fa-IR',
  'fi-FI',
  'fil-PH',
  'fr-FR',
  'gu-IN',
  'he-IL',
  'hi-IN',
  'hr-HR',
  'ht-HT',
  'hu-HU',
  'id-ID',
  'ig-NG',
  'is-IS',
  'it-IT',
  'ja-JP',
  'ka-GE',
  'km-KH',
  'kn-IN',
  'ko-KR',
  'lt-LT',
  'lv-LV',
  'mk-MK',
  'ml-IN',
  'mn-MN',
  'ms-MY',
  'my-MM',
  'my-QZ',
  'ne-IN',
  'nl-NL',
  'no-NO',
  'pa-PK',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'si-LK',
  'sk-SK',
  'sl-SI',
  'sn-ZW',
  'sq-AL',
  'sr-CS',
  'sr-SP',
  'sv-SE',
  'sw-KE',
  'ta-IN',
  'te-IN',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'ur-PK',
  'vi-VN',
  'yo-NG',
  'zh-CN',
  'zh-HK',
  'zh-TW',
  'zu-ZA',
] as const;
type LoginEnabledLocale = (typeof loginEnabledLocales)[number];
